import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserService } from 'netsocial-posting/src/app/services/user/user.service';
import { Subscription, from } from 'rxjs';
import { User } from 'netsocial-lib/src/app/interfaces/user';
import { ApiRequestService } from 'netsocial-lib/src/app/services/api-request/api-request.service';

@Component({
  selector: 'user-rank',
  templateUrl: './user-rank.component.html',
  styleUrls: ['./user-rank.component.scss'],
})
export class UserRankComponent implements OnInit, OnDestroy {
  constructor(private userService: UserService, private apiRequest: ApiRequestService) {}

  public rankSubscription?: Subscription;
  public userWithStats: User;

  private contextOwnerSubscription: Subscription;

  ngOnInit() {
    this.contextOwnerSubscription = this.apiRequest.getContextOwner().subscribe(() => {
      this.loadRank();
    });
  }

  ngOnDestroy() {
    this.rankSubscription?.unsubscribe();
    this.contextOwnerSubscription.unsubscribe();
  }

  private loadRank() {
    this.rankSubscription = from(
      this.userService.getTeamMemberById(this.userService.currentUser!.id, {
        includeStatistics: 1,
      })
    ).subscribe((user) => {
      this.userWithStats = user;
      this.rankSubscription = undefined;
    });
  }
}
